import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const FormRoutingEnabledTooltipMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: 'editor.options.payment.formRoutingEnabledTooltip'
});
export default FormRoutingEnabledTooltipMessage;